import React, { useState } from "react";
import PageHero from "./PageHero";
import img13 from "../../media/images/garary/046.jpg";
import img14 from "../../media/images/garary/g16.jpg";
import img15 from "../../media/images/garary/g4.jpg";
import img16 from "../../media/images/garary/g11.jpg";
import img17 from "../../media/images/garary/g10.jpg";
import img18 from "../../media/images/garary/Swimming.jpg";
import img19 from "../../media/images/garary/g8.jpg";
import img20 from "../../media/images/garary/g5.jpg";
import img21 from "../../media/images/garary/FH_UG-665.jpg";
import img22 from "../../media/images/garary/FH_UG-689.jpg";
import img23 from "../../media/images/garary/FH_UG-74.jpg";
import img24 from "../../media/images/garary/g1.jpg";

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [img13, img14, img15, img16, img17, img18, img19, img20, img21, img22, img23, img24];

  return (
    <>
      {/* HERO */}
      <PageHero
        title="Gallery"
        subtitle="Browse through our collection of images"
        image={img13}
      />

      <div className="container py-5">
        <h2 className="text-center mb-4" data-aos="fade-up">
          Our Gallery
        </h2>

        <div className="row">
          {images.map((img, index) => (
            <div
              className="col-md-4 mb-4"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div
                className="gallery-item"
                onClick={() => setSelectedImage(img)}
              >
                <img
                  src={img}
                  alt="Gallery"
                  className="img-fluid rounded shadow"
                />

                {/* HOVER OVERLAY */}
                <div className="overlay">
                  <span>View</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {selectedImage && (
        <div
          className="lightbox"
          onClick={() => setSelectedImage(null)}
        >
          <img src={selectedImage} alt="Large view" />
        </div>
      )}
    </>
  );
}

export default Gallery;